import "./SelectOpenComponentStyles.scss";
import { FC, useState, ChangeEvent } from "react";
import SelectOpenComponentProps from "./SelectOpenComponentProps";
import Icons from "../../assets/Icons";

const SelectOpenComponent: FC<SelectOpenComponentProps> = ({ title, children, search = false }) => {
    const [open, setOpen] = useState<boolean>(false);
    const [searchTerm, setSearchTerm] = useState<string>("");

    const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value);
    };

    return (
        <div className="select_open_open">
            <div
                className="form_underline d-flex hover justify-content-between align-items-center"
                onClick={() => setOpen(!open)}
            >
                {open && search ? (
                    <input
                        type="text"
                        className="form-control"
                        style={{ borderWidth: 0, textDecoration: "none" }}
                        placeholder="Buscar..."
                        value={searchTerm}
                        onClick={(e) => e.stopPropagation()} // para evitar que se cierre el dropdown
                        onChange={handleSearchChange}
                    />
                ) : (
                    title
                )}
                {open ? <Icons.ChevronUp /> : <Icons.ChevronBottom />}
            </div>
            {open && <div className="options">{typeof children === "function" ? children(searchTerm) : children}</div>}
        </div>
    );
};

export default SelectOpenComponent;
